<div class="pb-2">
  <input type="checkbox" [class.k-state-invalid]="showError" [formControl]="formControl" [formlyAttributes]="field"
    [attr.aria-label]="isHorizontalLayout ? to.label : null" kendoCheckBox />
  <label *ngIf="!isHorizontalLayout" [for]="id" class="k-checkbox-label">
    <span>
      {{ to.label }}
      <span *ngIf="to.required && to.hideRequiredMarker !== true" class="k-required">*</span>
    </span>
  </label>
  <small *ngIf="to.description" class="form-text text-muted d-block">{{ to.description }}</small>
</div>
